export default __webpack_public_path__ + "static/media/logoFooter.280b0faa.svg";